// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-header[data-v-769562ca] {\n    font-weight: 300;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-size: 16px;\n    margin: 20px 0;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
